import cn from 'classnames'
import { IoIosClose } from 'react-icons/io'
import { Button, If } from 'components/ideal-core-ui'

import s from './Modal.scss'

const Modal = ({
  isVisible,
  content,
  children,
  title,
  confirmCb,
  cancelCb,
  openModal,
  size,
  confirmText,
  cancelText,
  isDisabled,
  hideButtons
}) => (
  <>
    <div className={cn(s.container, { [s.hidden]: !isVisible })}>
      <section
        className={cn({
          [s.main]: true,
          [s.small]: size === 'sm',
          [s.medium]: size === 'md',
          [s.large]: size === 'lg',
          [s.extraLarge]: size === 'xl'
        })}
      >
        <If condition={title}>
          <section className={s.header}>
            <h2>
              <IoIosClose className={s.closeModal} onClick={cancelCb} />
              {title}
            </h2>
          </section>
        </If>
        <section className={s.content}>{content}</section>
        {!hideButtons && (
          <section className={s.footer}>
            <Button onClick={cancelCb} isSecondary>
              {cancelText}
            </Button>
            <Button onClick={confirmCb} isDisabled={isDisabled}>
              {confirmText}
            </Button>
          </section>
        )}
      </section>
    </div>
    {children ? children(openModal) : null}
  </>
)

Modal.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm'
}

export default Modal
